(ns kyber.styles.constants)

(def navbar-height 80)
(def footer-height 80)
(def brand-footer-height 32)
(def sign-up-banner-mobile-height 100)
(def account-page-max-width 1200)
(def volume-controls-min-height 20)
(def tab-bar-height 35)
